import { request } from './http'

export interface LoginPayload {
  /** 登录用户名。 */
  username: string
  /** 登录密码。 */
  password: string
}

export interface CurrentUser {
  /** 用户 ID。 */
  id: number
  /** 登录用户名。 */
  username: string
  /** 用户姓名。 */
  full_name?: string
  /** 是否超级管理员。 */
  is_superuser: boolean
  /** 角色编码列表。 */
  roles: string[]
  /** 权限编码列表。 */
  permissions: string[]
}

export interface LoginResponse {
  access_token: string
  token_type: string
  expires_in: number
  user: CurrentUser
}

/** 调用登录接口，返回 token 和用户信息。 */
export function loginApi(data: LoginPayload) {
  return request<LoginResponse>({ url: '/auth/login', method: 'POST', data })
}

/** 查询当前登录用户信息。 */
export function meApi() {
  return request<CurrentUser>({ url: '/auth/me', method: 'GET' })
}
